<template>
  <v-dialog v-model="dialogInstalaciones" :fullscreen="$vuetify.breakpoint.xsOnly" lazy max-width="90vw" scrollable @keydown.esc="close">
    <v-layout wrap align-start justify-start fill-height row>
      <v-flex xs12>
        <v-card flat tile color="primary" class=" pl-2 py-1">
          <span class="close-modal">
            <v-btn class="ma-0" color="error" @click.native.stop="close(true)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </span>
          <v-layout wrap align-center row fil-height class="mr-4">
            <v-flex sm4 md3 lg2>
              <v-autocomplete v-model="Cliente" :items="Clientes" :filter="selectFilterIncludes"
                              label="Cliente" item-text="label" item-value="value" class="mx-2 my-1 small-control" height="2px"
                              solo clearable :auto-select-first="true"
              />
            </v-flex>
            <v-flex sm4 md3 lg2>
              <v-autocomplete v-model="Instalacion" :items="loadInstalaciones" :filter="selectFilterIncludes"
                              label="Instalacion" item-text="label" item-value="value" class="mx-2 my-1 small-control"
                              solo clearable :auto-select-first="true"
              />
            </v-flex>
            <v-flex sm4 md3 lg2>
              <v-select v-model="tipoInfoInstalacion" :items="tiposInfoInstalacion" class="mx-2 my-1 small-control" solo />
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <component :is="infoInstalacion" ref="infoInstalacionRef" :key="switchInfoInstalacion" :cliente="Cliente" :instalacion="Instalacion" />
    </v-layout>
  </v-dialog>
</template>

<script>
import { Entities } from 'mixins/index.js'
import CopyChip from '@/components/CopyChip'
import Instalacion from './instalacion'
import Personas from './personas'
import Equipos from './equipos'

export default {
  name: 'Instalaciones',
  components: { CopyChip, Personas, Equipos, Instalacion },
  mixins: [ Entities ],
  props: {
    clienteProp: {
      type: [String, Number],
      default: '0'
    },
    instalacionProp: {
      type: [String, Number],
      default: '0'
    }
  },
  data () {
    return {
      classSteep: 'pa-3 back',
      Cliente: null,
      Instalacion: null,
      personasContacto: [],
      instalacionEquipo: [],
      tabActive: null,
      switchInfoInstalacion: 'Equipos',
      dialogInstalaciones: false,
      infoInstalacion: Equipos,
      tipoInfoInstalacion: 'Equipos',
      tiposInfoInstalacion: ['Equipos', 'Personas', 'Instalacion']
    }
  },
  computed: {
    loadInstalaciones () {
      if (this.Cliente) { return this.filterBy('instalacion', `${this.Cliente}/`) } else { return this.Instalaciones }
    }
  },
  watch: {
    tipoInfoInstalacion: function (value) {
      this.load()
    },
    Cliente: function (value) {
      if (this.loadInstalaciones.length === 1) { this.Instalacion = this.loadInstalaciones[0].value }
      if (!value) { this.Instalacion = null }
    },
    Instalacion: function (value) {
      if (value) {
        this.Cliente = parseInt(value.split('/')[0])
        this.load()
      }
    },
    dialogInstalaciones: function (value) {
      if (value) {
        document.documentElement.className += ' maximized-modal'
      } else {
        document.documentElement.className = document.documentElement.className.replace('maximized-modal', '')
        if (this.$router.history.current.query.back) {
          this.$router.go(-1)
        }
      }
    }
  },
  methods: {
    close () {
      this.dialogInstalaciones = false
    },
    show () {
      this.dialogInstalaciones = true
      this.$router.push({ query: { back: true } })
      setTimeout(() => {
        this.asyncClientes()
        this.asyncInstalaciones()
      }, 10)
      this.Cliente = Number(this.clienteProp) || null
      if (this.Cliente && Number(this.instalacionProp)) {
        this.Instalacion = `${this.Cliente}/${this.instalacionProp}`
      }
      if (Number(this.clienteProp) <= 0) {
        this.Cliente = this.$store.state.entities.idCliente || null
        if (this.$store.state.entities.idInstalacion) {
          this.Instalacion = `${this.Cliente}/${this.$store.state.entities.idInstalacion}`
        } else { this.Instalacion = null }
      }
      if (!this.Instalacion && this.$refs.infoInstalacionRef) this.$refs.infoInstalacionRef.clearn()
    },
    load () {
      if (this.Instalacion) {
        this.infoInstalacion = this.tipoInfoInstalacion
        this.$nextTick(() => {
          if (this.Instalacion && this.$refs.infoInstalacionRef) {
            this.$refs.infoInstalacionRef.load(this.Cliente, this.Instalacion.split('/')[1])
          }
        })
      }
    }
  }
}
</script>

<style >
.tabsStepper {
  width: 100%;
  padding: 0;
}
.tabsStepper .tabs {
  height: 80vh;
  min-width: 325px;
  width: 325px;
  overflow-y: auto;
}
.tabsStepper .items {
  height: 80vh;
  width: calc(100% - 325px);
  min-width: 240px;
}
.tabsStepper .items .v-stepper__wrapper > .v-card {
  height: 80vh;
  min-height: 100%;
}

.tabsStepper.theme--light .v-stepper__step.v-stepper__step--active,
.tabsStepper.theme--light .v-card {
  background-color: #f5f5f5 !important;
}
.tabsStepper.theme--dark .v-stepper__step.v-stepper__step--active,
.tabsStepper.theme--dark .v-card {
  background-color: #424242 !important;
}

.tabsStepper .v-stepper__step {
  padding: 4px 4px 4px 6px;
  border-bottom: 1px solid;
  border-color: #bdbdbd !important;
}
.tabsStepper .v-stepper__content {
  margin: 0 !important;
  padding: 0 !important;
  border-left: none !important;
}

.tabsStepper .v-stepper__content,
.tabsStepper .v-stepper__wrapper,
.tabsStepper .v-stepper__wrapper .v-card {
  transition: none !important;
}
.tabsStepper .v-tabs__slider-wrapper .v-tabs__slider {
  height: 4px !important;
}
.equipo-descripcion {
  display: contents;
}
@media only screen and (max-width: 599px) {
  .tabsStepper .tabs {
    height: 40vh;
  }
  .tabsStepper .items {
    height: 45vh;
    width: 100%;
  }
  .tabsStepper .items .v-stepper__wrapper > .v-card {
    height: unset;
    min-height: 100%;
  }
  .tabsStepper .v-stepper__step {
    padding: 3px 3px 3px 5px;
  }
  .equipo-descripcion {
    display: initial;
  }
  .equipo-descripcion span {
    margin-left: 10px;
  }
}
</style>
